import { BusinessMatterClient, PersonMatterClient } from '@models/matter';
import { MatterMortgage } from '@models/mortgage';
import { Selector } from '@ngxs/store';
import { MatterMortgagesState } from '@state/matter/matter_mortgages';
import { MatterClients } from './matter_clients';

export class MatterMortgageGuarantors {
	@Selector([
		MatterClients.get_guarantors,
		MatterMortgagesState.getAllMortgages,
	])
	static getMatterMortgageGuarantors(
		saleClients: (PersonMatterClient | BusinessMatterClient)[],
		matterMortgages: MatterMortgage[],
	): (mortgageId: string) => (PersonMatterClient | BusinessMatterClient)[] {
		return (mortgageId: string) => {
			const mortgage = matterMortgages?.find((x) => x.id === mortgageId);

			if (!mortgage) {
				return [];
			}

			return saleClients?.filter((x) => mortgage?.guarantors?.includes(x.id));
		};
	}

	@Selector([
		MatterClients.get_guarantors,
		MatterMortgagesState.getSelectedMortgage,
	])
	static getGuarantorsForSelectedMortgage(
		saleClients: (PersonMatterClient | BusinessMatterClient)[],
		mortgage: MatterMortgage,
	): (PersonMatterClient | BusinessMatterClient)[] {
		if (!mortgage) {
			return [];
		}

		return saleClients?.filter((x) => mortgage?.guarantors?.includes(x.id));
	}
}
